import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { analytics } from '../utils/analytics';

// Axious request timeout - by default axious imposes NO timeout
// refer to https://github.com/axios/axios/blob/main/README.md#request-config
const AXIOS_REQUEST_TIMEOUT = 20000;
export class ApiServices {
  private _httpClient: AxiosInstance;

  constructor(httpClient: any) {
    // Unit testing purposes only
    if(httpClient) {
      this._httpClient = httpClient;
      return;
    }

    this._httpClient = axios.create({ 
      baseURL:process.env.REACT_APP_BASE_API,
      timeout: AXIOS_REQUEST_TIMEOUT
    });
    
    this._httpClient.interceptors.request.use(
      (config) => {
        let teamsAccessToken;
        if(typeof sessionStorage !== 'undefined') {
          teamsAccessToken = sessionStorage.getItem('accessToken');

          // The teams auth token is intiailized and managed by the Layout component and persisted
          // in the session storage.
          if(teamsAccessToken) {
            config.headers['Authorization'] = `Bearer ${teamsAccessToken}`; 
          } 
          else {
            console.error('[apiServices] - accessToken not available');
            analytics.trackEvent('invalid_access_token', {
              apiService: true
            });
          }

          return config;
        }
      },
      (error) => {
        console.log(error);
        Promise.reject(error);
      }
    );

    this._httpClient.interceptors.request.use(this.authenticationInterceptor);
  }

  public getToken = () => {
    this._httpClient.interceptors.request.use(this.authenticationInterceptor);
  };
  public async getChatThreadList(): Promise<any> {
    try {
      await this.getToken();
      // const { data } = await this._httpClient.get<any>(`/chatThreadList`);
      const { data } = await this._httpClient.get<any>(`/api/TicketData/activeTicket`);
      if (data.status === 0) {
        return data.result;
      } else {
        console.log(data.errorMessage);
      }
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  //不调用
  public async getUserInfo(userId: string, appId: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<any>(`/api/main/customerInfo?appId=${appId}&userId=${userId}`);
      if (data.status === 0) {
        return data.result;
      } else {
        console.log(data.errorMessage);
      }
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async getSupportInfo(): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<any>(`/api/main/supportInfo`);
      if (data.status === 0) {
        return data.result;
      } else {
        console.log(data.erroMessage);
      }
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async getRefreshToken(userIdentity: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<String>(`/api/acs/refreshToken/${userIdentity}`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async postMessageToWechat(body: any, analyticsData?: any): Promise<any> {
    let startTime = new Date();
    try {
      analytics.trackEvent('post_message_to_wechat_begin',  {
        ...analyticsData
      });
      await this.getToken();
      const res = await this._httpClient.post<any>(`/api/main/sendMessage`, body);
      const data = res?.data;

      const endTime = new Date();
      analytics.trackEvent('post_message_to_wechat_success',  {
        ...analyticsData,
        responseTime: endTime.getTime() - startTime.getTime()
      });

      return data;
    } catch (exception) {
      analytics.trackException(exception);

      const endTime = new Date();
      analytics.trackEvent('post_message_to_wechat_fail', {
        ...analyticsData,
        responseTime: endTime.getTime() - startTime.getTime()
      });

      // rethrow - let the client know
      throw exception;
    }
  }
  public async transferTicket(body: any): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<any>(`/api/main/transferTicket`, body);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async postChangeStatus(body: any): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<String>(`/api/main/changeStatus`, body);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async getUserSettings(): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<String>(`/api/main/userSettings`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async postUserSettings(body: any): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<String>(`/api/main/userSettings`, body);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  // { ChatThreadId: "",Comment: ""}
  public async postEndChat(body: any): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<String>(`/api/main/endChat`, body);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  // 错误消息重发接口
  public async sendretryMessage(body: any): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<String>(`/api/main/sendretryMessage`, body);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async getCategroylist(): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<String>(`/api/KnowLedgeBase/categorylist`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async postCteatedCategroy(body: any, isAdmin: boolean): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<String>(
        `/api/KnowLedgeBase${isAdmin ? '/admin' : ''}/category`,
        body
      );
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async postCteatedItem(body: any, isAdmin: boolean): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<String>(`/api/KnowLedgeBase${isAdmin ? '/admin' : ''}/item`, body);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async DelCategroy(ParentsId: string, isAdmin: boolean): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.delete<String>(
        `/api/KnowLedgeBase${isAdmin ? '/admin' : ''}/category/${ParentsId}`
      );
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async DelItem(ParentsId: string, isAdmin: boolean): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.delete<String>(
        `/api/KnowLedgeBase${isAdmin ? '/admin' : ''}/item/${ParentsId}`
      );
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async getKnowLedgeBaseCategoryList(): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<string>(`/api/KnowLedgeBase/categorylist`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async getKnowLedgeBaseCategory(categoryid: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<string>(`/api/KnowLedgeBase/item/${categoryid}`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async postKnowLedgeBase(body: any): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<string>(`/api/KnowLedgeBase/item`, body);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  public async modifyCategroy(body: any, isAdmin: boolean): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.patch<String>(
        `/api/KnowLedgeBase${isAdmin ? '/admin' : ''}/category`,
        body
      );
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async modifyItem(body: any, isAdmin: boolean): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.patch<String>(`/api/KnowLedgeBase${isAdmin ? '/admin' : ''}/item`, body);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async getItem(CategoryId: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<String>(`/api/KnowLedgeBase/item/${CategoryId}`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async getHistoricalDialogue(appId: any, customerId: any, createAtStart: string, limit: number): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<String>(
        `api/main/history/${appId}/${customerId}/?createAtStart=${createAtStart}&limit=${limit}`
      );
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  /**
   * This interceptor add Bearer token in http header for every request
   */
  protected authenticationInterceptor = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
    config.headers = {
      ...config.headers
    };
    return config;
  };
  public async getUserAgentStatus(): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<String>(`/api/user/agentStatus`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async getTicket(ticketId: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<String>(`/api/TicketData/ticket/${ticketId}`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  //日志列表
  public async getLogList(params: any): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<String>(`/api/TicketData/history`, { params });
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  //历史记录
  public async getHistoryForTicket(params: any, ticketId: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<String>(`/api/message/historyForTicket/${ticketId}`, { params });
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  //继续接入
  public async createNewFromOld(ticketId: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<string>(`/api/main/createNewFromOld/${ticketId}`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  //是否可接入
  public async followupablemessagenumber(ticketid: string, customerId: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<string>(
        `/api/Message/followupablemessagenumber/${ticketid}?customerId=${customerId}`
      );
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  //监控页面列表
  public async uncloseTicket(): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<string>(`/api/TicketData/uncloseTicket`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  // {{HostName}}/joinTicket/010000018021e6b1c50000000000000000
  // 监控台管理员介入
  public async joinTicket(id: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<string>(`/api/main/joinTicket/${id}`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  // 监控台管理员接入
  public async accessTicket(id: string): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.post<string>(`/api/main/accessTicket/${id}`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  //管理员介入列表
  public async activeInterveneTicket(): Promise<any> {
    try {
      await this.getToken();
      // const { data } = await this._httpClient.get<any>(`/chatThreadList`);
      const { data } = await this._httpClient.get<any>(`/api/TicketData/activeInterveneTicket`);
      if (data.status === 0) {
        return data.result;
      } else {
        console.log(data.errorMessage);
      }
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

  //管理员设置
  public async maxChatNumber(userId: any, newVaule: any): Promise<any> {
    try {
      await this.getToken();
      // const { data } = await this._httpClient.get<any>(`/chatThreadList`);
      const { data } = await this._httpClient.patch<any>(`/api/user/maxChatNumber/${userId}/${newVaule}`);
      if (data.status === 0) {
        return data.result;
      } else {
        console.log(data.errorMessage);
      }
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  //管理员列表
  public async listAgent(): Promise<any> {
    try {
      await this.getToken();
      // const { data } = await this._httpClient.get<any>(`/chatThreadList`);
      const { data } = await this._httpClient.get<any>(`/api/user/listAgent`);
      if (data.status === 0) {
        return data.result;
      } else {
        console.log(data.errorMessage);
      }
    } catch (exception) {
      analytics.trackException(exception);
    }
  }
  public async getTicketableAgent(): Promise<any> {
    try {
      await this.getToken();

      const { data } = await this._httpClient.get<String>(`/api/user/ticketableAgent`);
      return data;
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

    // 上传图片
    public async uploadfiletowehatandblob(
      tenantId: string,
      appId: string,
      fileData: any, 
      analyticsData: any = {}): Promise<any> {

      if(!tenantId) {
        throw `tenantId is required`;
      }

      if(!appId) {
        throw `appId is required`;
      }

      if(!fileData) {
        throw `fileData is required`;
      }

      const startTime = new Date();
      try {
        analytics.trackEvent('upload_file_to_wechat_and_blob_begin', {
          ...analyticsData,
          tenantId,
          appId,
        });

        await this.getToken();
        let postResult = await this._httpClient.post<string>(
          `/api/file/uploadfiletowehatandblob/${tenantId}/${appId}`,
          fileData,
          {
            headers:{
              "Content-Type": "multipart/form-dat"
            },
            baseURL:process.env.REACT_APP_UPDATA_BASE_API
          }
        )
        .then( res => {
          const endTime = new Date();
          analytics.trackEvent('upload_file_to_wechat_and_blob_success', {
            ...analyticsData,
            tenantId,
            appId,
            res,
            responseTime: endTime.getTime() - startTime.getTime()
          });

          return res;
        })
        .catch(exception => {
          const endTime = new Date();
          analytics.trackEvent('upload_file_to_wechat_and_blob_fail', {
            ...analyticsData,
            tenantId,
            appId,
            exception,
            responseTime: endTime.getTime() - startTime.getTime()
          });

          analytics.trackException(exception);
          // let the client know it failed
          throw exception;
        });

        return postResult?.data;

      } catch (exception) {
        const endTime = new Date();
        analytics.trackEvent('upload_file_to_wechat_and_blob_fail', {
          ...analyticsData,
          tenantId,
          appId,
          exception,
          responseTime: endTime.getTime() - startTime.getTime()
        });

        analytics.trackException(exception);
        throw exception;
      }
    }

    
  public async getUrlWithSas(url: any): Promise<any> {
    try {
      await this.getToken();
      const { data } = await this._httpClient.get<any>(`/api/file/getUrlWithSas?url=${encodeURIComponent(url)}`, {baseURL:process.env.REACT_APP_UPDATA_BASE_API});
      if (data.status === 0) {
        return data.result;
      } else {
        console.log(data.errorMessage);
      }
    } catch (exception) {
      analytics.trackException(exception);
    }
  }

    public async remoteIp(): Promise<any> {
      try {
        await this.getToken();
        const { data } = await this._httpClient.get<String>(`/api/file/remoteIp`,{baseURL:process.env.REACT_APP_UPDATA_BASE_API});
        return data;
      } catch (error) {
        console.error('Failed at getting isThreadIdValid, Error: ', error);
      }
    }
    
}

export const apiServices = new ApiServices(false);
export const createApiServices = (httpClient: any) => new ApiServices(httpClient);
